import { BaseService } from "../BaseService";
import { API_ROUTES } from "../../constants/routes";

class PatientsService extends BaseService {
  constructor(url) {
    super(url);
    this.getPatientsList = this.getPatientsList.bind(this);
    this.savePatient = this.savePatient.bind(this);
    this.deletePatient = this.deletePatient.bind(this);
    this.updatePatient = this.updatePatient.bind(this);
  }

  async getPatientsList({ labId, perPage, page, params = {} }) {
    try {
      const response = await this.agent.get("", {
        params: {
          dental_lab_id: labId,
          order: "asc",
          page,
          per_page: perPage,
          sort_by: "first_name",
          ...params,
        },
      });

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      throw error;
    }
  }

  async savePatient(data) {
    try {
      const response = await this.agent.post("", data);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }

  async deletePatient(patientId) {
    try {
      const response = await this.agent.delete(`/${patientId}`);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }

  async updatePatient(patientId, data) {
    try {
      const response = await this.agent.patch(`/${patientId}`, data);

      return Promise.resolve(response);
    } catch (error) {
      this.processError(error);
      return null;
    }
  }
}

const ServiceInstance = new PatientsService(API_ROUTES.patients);

export default ServiceInstance;
export { ServiceInstance as PatientsService };
